import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { updateLoading, updateTitle } from 'store/app';
import { assetDetails, returnAsset } from 'store/asset';
import { Icon } from '@iconify/react';
import { getImage } from 'hooks/get-image';
import cn from 'classnames';
import Button from 'components/ui/Button';
import CategoryBadge from 'components/common/CategoryBadge';
import StarRating from 'components/common/StartRating';
import { createReview } from 'store/review';
import { comment } from 'postcss';
import SwipeButton from 'components/ui/SwipeButton';

const AssetReview = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [rating, setRating] = useState(false);
  const [comment, setComment] = useState('');
  const [completed, setCompleted] = useState(false);

  const { selected } = useSelector(state => state.asset);
  const { language } = useSelector((state) => state.app);

  const { id } = useParams();

  const handleReturn = () => {
    dispatch(returnAsset(selected.id))
      .then((res) => {
        if (res.payload.Result) {
          setCompleted(true);
          navigate('/locker/opened');
        }
      })
      .catch(() => {
        setCompleted(true);
      })
  }

  const handleReview = () => {
    setCompleted(false);
    dispatch(createReview({ asset: selected.id, rating: rating, comment: comment }))
      .then((res) => {
        if (res.payload.Result) {
          handleReturn()
        }
      })
  }

  const fetchDetails = () => {
    //dispatch(updateLoading(true))
    dispatch(assetDetails(id))
      .then(() => {
        dispatch(updateLoading(false))
      })
      .catch(() => {
        dispatch(updateLoading(false))
      })
  }

  useEffect(() => {
    fetchDetails();
    dispatch(updateTitle(t('review.write')))
  }, [])

  return (
    selected &&
    <div className="h-full w-full px-8 flex flex-col gap-10 pb-5">
      <div className="flex items-center gap-5">
        <img
          alt={selected.id}
          src={getImage(selected.files)}
          className="h-24"
        />
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <span className="text-lg font-semibold">
              {selected?.name}
            </span>
            <span className="text-[#808080]">
              ({selected?.category?.name[language]})
            </span>
          </div>
          <div className="flex items-center gap-3">
            <CategoryBadge category={selected.category} />
            <div className="flex items-center gap-1 text-[#808080]">
              <Icon icon="ic:round-star" />
              <span>
                ({selected.average ?? '--'})
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-5">
        <div className="flex gap-0.5">
          <span className="text-lg font-semibold">
            {t('review.text')}
          </span>
          <span className="text-lg font-semibold text-red-500">
            *
          </span>
        </div>
        <StarRating
          onChange={(rate) => setRating(rate)}
          initialRating={rating}
        />
      </div>
      <div className="flex flex-col gap-3 h-full">
        <div className="flex items-center gap-1">
          <span className="text-lg font-semibold">
            {t('review.tell_us_more')}
          </span>
          <span className="text-[#808080] lowercase">
            ({t('general.optional')})
          </span>
        </div>
        <textarea
          id="comment"
          name="comment"
          rows="5"
          style={{ resize: 'none' }}
          className="w-full border border-[#e7e7e7] rounded-2xl py-4 px-3 focus:outline-none"
          value={comment}
          onChange={(e) => comment.length < 300 ? setComment(e.target.value) : null}
          placeholder={t('review.text_placeholder')}
        />
        <div className="flex items-center text-[#808080] gap-1 text-sm">
          <span>
            {comment.length} / 300
          </span>
          <span className="lowercase">
            {t('general.max_chars')}
          </span>
        </div>
      </div>
      <div>

        <SwipeButton
          onComplete={handleReview}
          text={t('review.review_it_and_open')}
          completed={completed}
          loadingText={t('locker.opening_door')}
          completeText={t('locker.door_opened')}
          disabled={!rating}
        />
        {/* <Button
          onClick={handleReview}
          color="dark"
          size="lg"
          text={t('review.review_it')}
          isDisabled={!rating}
        /> */}
      </div>
      {/* <div>
        <Button
          onClick={handleReturn}
          color="dark"
          size="lg"
          text={t('asset.return')}
        />
      </div> */}
    </div>
  )
}

export default AssetReview;